import {OpportunitiesFilter} from "./component/calculationsFilter/OpportunitiesFilter";
import {ConditionTypeFilter} from "./component/conditionTypeFilter/ConditionTypeFilter";
import {OpportunityFilterModule} from "./OpportunityFilterModuleConfiguration";

OpportunityFilterModule
    .createNewModule()
    .component('opportunityConditionTypeFilter', ConditionTypeFilter.instance)
    .component('opportunitiesFilter', OpportunitiesFilter.instance);
